// @flow
/**
 * Created by Mike Chung on 2/27/18.
 */
import React from "react";
import * as _ from "lodash";

type TableBodyProps = {
    className?: string
}

export default function TableBody(props: TableBodyProps) {
    const {className, ...rest} = props;
    let clazz = `divTableBody ${_.defaultTo(className, "")}`;
    return (
        <div className={clazz} {...rest} />
    );
}


// WEBPACK FOOTER //
// ./src/components/util/tables/TableBody.js